module.exports = __webpack_public_path__ + "static/media/fin-tabs.b11b0fbd.jpg";